import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M9 8.25V3.006a.755.755 0 0 1 .842-.75 6.8 6.8 0 0 1 5.902 5.902.755.755 0 0 1-.75.842H9.75A.75.75 0 0 1 9 8.25",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M6 3.57A6.372 6.372 0 1 0 14.43 12"
	})]
});
export default SvgReportsinline;
